/**
 * @file component-config
 * @version 1.0.1
 * @author wuwg  <wuwg@thunisoft.com>
 * @createTime  2019-08-13
 * @updateTime  2019-08-13
 * @copyright thunisoft fd
 * @see [jsDoc中文文档]{@link  http://www.dba.cn/book/jsdoc/JSDOCKuaiBiaoQianBLOCKTAGS/CONSTRUCTS.html}
 * @description  组件的配置文件
 */
export default {
    name: 'config',
    // 公用组件前缀
    componentCcPrefix:'cc',
    // 公用业务组件前缀
    componentAcPrefix:'ac',
    // class模块前缀
    classPrefix:'fd'
};



// WEBPACK FOOTER //
// ./src/components/config/component-config.js